import React from 'react';
import * as api from '../../api';
import { useTranslation } from 'react-i18next';
import Spinner from '../../Plateforme/Atoms/Spinner';
import BoldBlue from '../Atoms/BoldBlue';
import { Link } from 'react-router-dom';
import Popup from '../Atoms/Popup';
import BlueButton from '../Atoms/BlueButton';
import DynamicallyTranslatedText from '../Atoms/DynamicallyTranslatedText';

const Collaborators = (props) => {

    const [collaborators, setCollaborators] = React.useState([]);
    const [collaboratorToDelete, setCollaboratorToDelete] = React.useState(null);
    const [loading, setLoading] = React.useState(true);
    const [statusMessage, setStatusMessage] = React.useState(null);
    const { i18n } = useTranslation('common');

    React.useEffect(() => {
        if(!props.company || !props.company.company) return;
        loadCollaborators()
    }, [props.company]);

    function loadCollaborators(){
        api.GetCollaborators({hubspotID : props.company.company.hubspotID}).then((response) => {
            // console.log("collabs found :");
            // console.log(response.data);
            setCollaborators(response.data);
            setLoading(false);
        }).catch((error) => {
            console.log(error);
        });
    }

    if(loading){
        return (
            <>
                <br/><br/>
                <Spinner/>
                <br/><br/>
            </>
        )
    }

    function deleteCollaborator(collaborator){
        setCollaboratorToDelete(collaborator);
    }

    function confirmDeleteCollaborator(e){
        e.preventDefault();
        setStatusMessage("loading");
        const userIdToDelete = collaboratorToDelete.user._id;
        api.DeleteAccount({userIdToDelete}).then(() => {
            console.log("account deleted");
            setStatusMessage(i18n.language === "fr" ? "Compte supprimé." : "Account deleted.");
            loadCollaborators();
        }).catch((error) => {
            console.log(error);
            setStatusMessage(i18n.language === "fr" ? "Une erreur est survenue." : "An error occurred.");
            loadCollaborators();
        });
    }

    return (
        <>
            <BoldBlue>{i18n.language === "fr" ? "Collaborateurs" : "Partners"}</BoldBlue><br/>
            {collaborators.map((collaborator) => {
                return (
                    <div key={collaborator.user._id}>
                        <span style={{width:"100%"}}>{collaborator.hsProfile?.properties?.firstname} {collaborator.hsProfile?.properties?.lastname}{!props.readonly && collaborator.user._id !== props.company.company.ownerUserId && 
                        <img alt="" style={{margin:"0 5px 0 0",display:"inline-block",float:"right",width:"13px",cursor:"pointer"}} src='/img/x_noir.png' onClick={() => deleteCollaborator(collaborator)}/>}
                        </span><br/>
                        {/* {collaborator.hsProfile?.properties?.jobtitle && <><span>{collaborator.hsProfile?.properties?.jobtitle}</span><br/></>} */}
                        {collaborator.hsProfile?.properties?.jobtitle && <><span><DynamicallyTranslatedText text={collaborator.hsProfile?.properties?.jobtitle} targetLang={i18n.language} context={"Job title"} /></span><br/></>}
                        <Link to={"/profile?id=" + btoa(collaborator.user.email) + (props.publicView ? "&public_view=1" : "")}>
                            <BoldBlue style={{display:"inline-block"}}><img alt="" style={{margin:"0 5px 0 0",display:"inline-block"}} src='/img/fleche_bleue.png'/>{i18n.language === "fr" ? "Voir le profil" : "See profile"}</BoldBlue>
                        </Link><br/><br/>
                    </div>
                )
            })}
            {collaboratorToDelete && <Popup close={() => setCollaboratorToDelete(null)}><br/>
                {i18n.language === "fr" ? "Êtes-vous sûr de vouloir supprimer " : "Are you sure you want to delete "} {collaboratorToDelete.hsProfile?.properties?.firstname} {collaboratorToDelete.hsProfile?.properties?.lastname} ? {i18n.language === "fr" ? "Le compte du collaborateur sera supprimé et il n'aura plus accès à la plateforme." : "The collaborator's account will be deleted and he will no longer have access to the platform."}
                <br/><br/>
                <span>
                    {statusMessage === "loading" ? <Spinner/> : (
                        statusMessage ? <>{statusMessage}</> : <>
                            <BlueButton onClick={(event) => {event.preventDefault(); setCollaboratorToDelete(null)}}>{i18n.language === "fr" ? "Annuler" : "Cancel"}</BlueButton>&nbsp;&nbsp;&nbsp;&nbsp;
                            <BlueButton onClick={confirmDeleteCollaborator}>{i18n.language === "fr" ? "Supprimer" : "Delete"}</BlueButton>
                        </>
                    )}
                </span>
            </Popup>}
        </>
    );
}

export default Collaborators;